(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/buyin-filter.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/buyin-filter.js');
"use strict";


const _svs$ui$ReactDropdown = svs.ui.ReactDropdown,
  DropdownSelectItem = _svs$ui$ReactDropdown.DropdownSelectItem,
  DropdownItem = _svs$ui$ReactDropdown.DropdownItem,
  DropdownLabel = _svs$ui$ReactDropdown.DropdownLabel;
const _svs$poker_react$comp = svs.poker_react.components.common.constants,
  BuyinFiltersSEK = _svs$poker_react$comp.BuyinFiltersSEK,
  BuyinFiltersEUR = _svs$poker_react$comp.BuyinFiltersEUR;
const BuyinFilter = _ref => {
  let activeBuyinFilter = _ref.activeBuyinFilter,
    isNetwork = _ref.isNetwork,
    setActiveBuyinFilter = _ref.setActiveBuyinFilter;
  const filters = isNetwork ? BuyinFiltersEUR : BuyinFiltersSEK;
  return React.createElement("div", {
    className: "poker-filter-dropdown"
  }, React.createElement(DropdownSelectItem, {
    branding: "poker-react",
    onSelect: selected => setActiveBuyinFilter(JSON.parse(selected)),
    selectLabel: "Ink\xF6p",
    v2: true
  }, filters.map(filter => React.createElement(DropdownItem, {
    key: filter.id,
    name: JSON.stringify(filter),
    selected: activeBuyinFilter.id === filter.id
  }, React.createElement(DropdownLabel, null, filter.title)))));
};
setGlobal('svs.poker_react.components.upcomingEvents.BuyinFilter', BuyinFilter);

 })(window);